module.exports = __webpack_public_path__ + "img/learner-quiz-Connoisseur-Shadow.d00153e5.png";